export default __webpack_public_path__ + "static/media/Mask of the Death Master (nm).6164a4df.jpg";